import {
  OrderProduct,
  Product,
  StandardOrderProduct,
} from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";

interface ProductItemPriceProps {
  product: Product | OrderProduct | StandardOrderProduct;
  className?: string;
}

const SelfAssemblyProductItemPrice = ({
  product,
  className,
}: ProductItemPriceProps) => {
  return (
    <div className={className}>
      <Text className="gg-text-lg gg-font-bold">
        {getFormattedPrice(product.totalPrice)}
      </Text>
      <Text className="gg-text-start gg-text-xs gg-text-dark-blue-800">
        zelfmontage prijs
      </Text>
    </div>
  );
};
export default SelfAssemblyProductItemPrice;
